<template>
  <div>
    <div class="card card-custom card-sticky" v-if="!mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer">
            <span class="label label-xl label-dot label-success mr-2"></span> Turno 3 <i class="mr-2"></i>
            <small v-if="ui.estaCargandoDatos" class="">Cargando datos de la ficha...</small>
            <small v-else-if="auth.mensajeNoAutorizadoEdicionTurno" class="text-danger">{{ auth.mensajeNoAutorizadoEdicionTurno }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <a href="#" class="btn btn-sm btn-light font-weight-bold" @click.prevent="doCargarFicha()"><i class="fa p-0 fa-sync" :class="[ui.estaCargandoDatos ? 'fa-spin ' : '']"></i></a>
        </div>
      </div>
    </div>
    <div class="card card-custom card-sticky" v-if="mostrarDetalleFicha">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label cursor-pointer" @click.prevent="$emit('update:expandirContenido', !expandirContenido)">
            <span class="label label-xl label-dot label-success mr-2"></span> Turno 3 <i class="mr-2"></i>
            <small class="">{{ auth.fechaInicioTurno | time }} - {{ auth.fechaFinTurno | time }}</small>
          </h3>
        </div>
        <div class="card-toolbar">
          <span v-if="auth.puedeCambiarEstadoFinalizado == true">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2" v-b-tooltip.left title="Presione para desbloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-lock"></i>Finalizado</a>
            <a href="#" v-if="finalizado == false" class="btn btn-sm btn-light font-weight-bold mr-2" v-b-tooltip.left title="Presione para bloquear" @click.prevent="doToggleFinalizado()"> <i class="fa fa-unlock-alt"></i>Desbloquear</a>
          </span>
          <span v-if="auth.puedeCambiarEstadoFinalizado == false">
            <a href="#" v-if="finalizado == true" class="btn btn-sm btn-light-danger font-weight-bold mr-2"> <i class="fa fa-lock"></i>Finalizado</a>
          </span>

          <a href="#" class="btn btn-sm font-weight-bold mr-2" :class="isDirty ? 'btn-success' : 'btn-light-success'" @click.prevent="doGuardado()"><i class="fa" :class="[ui.estaGuardando ? 'fa-spinner fa-spin p-0 fa-align-center mr-1' : 'fa-save']"></i> Guardar cambios</a>

          <a href="#" class="btn btn-sm btn-light-warning font-weight-bold" @click.prevent="$emit('update:expandirContenido', !expandirContenido)"><i class="fa p-0" :class="[expandirContenido ? 'fa-chevron-up' : 'fa-chevron-down']"></i></a>
        </div>
      </div>
      <div class="card-body" v-show="expandirContenido">
        <form class="form" id="frm-turno-3">
          <div class="row">
            <div class="col-xl-2"></div>
            <div class="col-xl-8">

              <!-- I. CONDICIONES GENERALES -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">I. Condiciones generales</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">1.1. ¿El local de votación cuenta con electricidad?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3LocalCuentaConElectricidad = true" class="btn" :class="[actual.t3LocalCuentaConElectricidad === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3LocalCuentaConElectricidad = false" class="btn" :class="[actual.t3LocalCuentaConElectricidad === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">1.2. Seleccionar la presencia de:</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group mb-2" role="group">
                      <button type="button" @click.prevent="actual.t3PresenciaOnpe = !actual.t3PresenciaOnpe" class="btn" :class="[actual.t3PresenciaOnpe ? 'btn-primary' : 'btn-outline-secondary']">ONPE</button>
                      <button type="button" @click.prevent="actual.t3PresenciaJne = !actual.t3PresenciaJne" class="btn" :class="[actual.t3PresenciaJne ? 'btn-primary' : 'btn-outline-secondary']">JNE</button>
                      <button type="button" @click.prevent="actual.t3PresenciaFfaapnp = !actual.t3PresenciaFfaapnp" class="btn" :class="[actual.t3PresenciaFfaapnp ? 'btn-primary' : 'btn-outline-secondary']">FFAA / PNP</button>
                      <button type="button" @click.prevent="actual.t3PresenciaMinisterioPublico = !actual.t3PresenciaMinisterioPublico" class="btn" :class="[actual.t3PresenciaMinisterioPublico ? 'btn-primary' : 'btn-outline-secondary']">Min. Público</button>
                      <button type="button" @click.prevent="actual.t3PresenciaDefensoriaDelPueblo = !actual.t3PresenciaDefensoriaDelPueblo" class="btn" :class="[actual.t3PresenciaDefensoriaDelPueblo ? 'btn-primary' : 'btn-outline-secondary']">Defensoría</button>
                    </div>
                    <div class="mt-2">
                      <label class="checkbox checkbox-lg">
                        <input type="checkbox" v-model="actual.t3PresenciaOtros" :value="true" />
                        <span class="mr-2"></span>Otros
                      </label>
                      <textarea v-if="actual.t3PresenciaOtros" v-model="actual.t3PresenciaOtrosDetalle" class="form-control mt-2" type="text" placeholder="Indicar el nombre de la entidad..." required></textarea>
                    </div>
                  </div>
                </div>
              </div>

              <!-- II. CIERRE DEL LOCAL DE VOTACIÓN -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">II. Cierre del local de votación</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.1. Señale la hora en la que cerró el local de votación:</label>
                  <div :class="ui.colRightClass">
                    <input type="time" class="form-control" v-model="actual.t3HoraCierreLocal" />
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.2. Después del cierre de puertas, ¿quedaron personas dentro del local de votación esperando sufragar?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3QuedaronPersonasEsperandoSufragar = true" class="btn" :class="[actual.t3QuedaronPersonasEsperandoSufragar === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3QuedaronPersonasEsperandoSufragar = false" class="btn" :class="[actual.t3QuedaronPersonasEsperandoSufragar === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3QuedaronPersonasEsperandoSufragar === true" v-model="actual.t3QuedaronPersonasEsperandoSufragarDetalle" class="form-control mt-2" type="text" placeholder="Señale brevemente..." required></textarea>
                    <textarea v-if="actual.t3QuedaronPersonasEsperandoSufragar === false" v-model="actual.t3QuedaronPersonasEsperandoSufragarDetalleNo" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué no..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">2.3. ¿Se permitió votar a las personas que permanecían dentro del local tras el cierre de puertas?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3SePermitioVotarTrasCierre = true" class="btn" :class="[actual.t3SePermitioVotarTrasCierre === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3SePermitioVotarTrasCierre = false" class="btn" :class="[actual.t3SePermitioVotarTrasCierre === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3SePermitioVotarTrasCierre === false" v-model="actual.t3SePermitioVotarTrasCierreDetalleNo" class="form-control mt-2" type="text" placeholder="Señale brevemente por qué no..." required></textarea>
                  </div>
                </div>
              </div>

              <!-- VI. ASPECTOS CRÍTICOS OBSERVADOS -->
              <div class="my-5">
                <h3 class=" text-dark font-weight-bold mb-10">VI. Aspectos críticos observados</h3>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">6.1. ¿Se observó dentro del local de votación algún acto de intimidación o violencia que impidiera el ejercicio del voto ciudadano?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3ActoIntimidacionOViolencia = true" class="btn" :class="[actual.t3ActoIntimidacionOViolencia === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3ActoIntimidacionOViolencia = false" class="btn" :class="[actual.t3ActoIntimidacionOViolencia === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3ActoIntimidacionOViolencia === true" v-model="actual.t3ActoIntimidacionOViolenciaDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">6.2. ¿Se produjo alguna acción que impidiera su labor como observador/a electoral?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AccionImpideLaborObservador = true" class="btn" :class="[actual.t3AccionImpideLaborObservador === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AccionImpideLaborObservador = false" class="btn" :class="[actual.t3AccionImpideLaborObservador === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3AccionImpideLaborObservador === true" v-model="actual.t3AccionImpideLaborObservadorDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">6.3. ¿Se reportó el abandono de algún miembro de mesa?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3ReporteAbandonoMiembroMesaLocal = true" class="btn" :class="[actual.t3ReporteAbandonoMiembroMesaLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3ReporteAbandonoMiembroMesaLocal = false" class="btn" :class="[actual.t3ReporteAbandonoMiembroMesaLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t3ReporteAbandonoMiembroMesaLocal === true">
                      <input type="text" class="form-control mt-2" v-model="actual.t3ReporteAbandonoMiembroMesaLocalNroMesa" placeholder="Número de mesa..." required />
                      <textarea v-model="actual.t3ReporteAbandonoMiembroMesaLocalDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">6.4. ¿Se observaron altercados entre personeros de organizaciones políticas y/o ciudadanos?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3AltercadosEntrePersonerosOCiudadanos = true" class="btn" :class="[actual.t3AltercadosEntrePersonerosOCiudadanos === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3AltercadosEntrePersonerosOCiudadanos = false" class="btn" :class="[actual.t3AltercadosEntrePersonerosOCiudadanos === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <div v-if="actual.t3AltercadosEntrePersonerosOCiudadanos === true" class="mt-2">
                      <label class="mb-1">Organizaciones políticas involucradas:</label>
                      <div class="card-body py-0">
                        <table class="table mb-0">
                          <tbody>
                            <tr v-for="(item, index) in actual.itemsT3AltercadosEntrePersoneros" :key="'t3alt-' + index">
                              <td><img class="symbol-label" :src="getImagenPartidoPolitico(item.organizacionPoliticaParamId)" style="width:40px;height:auto;" /></td>
                              <td class="w-75">
                                <select class="form-control" v-model="item.organizacionPoliticaParamId">
                                  <option :value="null">- Seleccione organización -</option>
                                  <optgroup label="Partidos Políticos">
                                    <option v-for="partido in partidosNacionales" :key="partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup>
                                  <!-- <optgroup label="Movimientos Regionales">
                                    <option v-for="partido in partidosRegionales" :key="'mr-' + partido.parametroId" :value="partido.parametroId">{{ partido.descripcion }}</option>
                                  </optgroup> -->
                                </select>
                              </td>
                              <td><a href="#" class="btn btn-outline-secondary" @click.prevent="deleteItemPersoneroAltercados(actual.itemsT3AltercadosEntrePersoneros, item)"><i class="fa fa-trash p-0 text-danger"></i></a></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <a href="#" class="btn btn-secondary btn-sm" @click.prevent="addItemPersoneroAltercados(actual.itemsT3AltercadosEntrePersoneros)"><i class="fa fa-plus"></i> Agregar</a>
                      <textarea v-model="actual.t3AltercadosEntrePersonerosOCiudadanosDetalle" class="form-control mt-2" type="text" placeholder="Describa brevemente..." required></textarea>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label :class="ui.colLeftClass">6.5. ¿Observaste algún otro incidente?</label>
                  <div :class="ui.colRightClass">
                    <div class="btn-group btn-group" role="group">
                      <button type="button" @click.prevent="actual.t3OtroIncidenteLocal = true" class="btn" :class="[actual.t3OtroIncidenteLocal === true ? 'btn-success' : 'btn-outline-secondary']">Sí</button>
                      <button type="button" @click.prevent="actual.t3OtroIncidenteLocal = false" class="btn" :class="[actual.t3OtroIncidenteLocal === false ? 'btn-danger' : 'btn-outline-secondary']">No</button>
                    </div>
                    <textarea v-if="actual.t3OtroIncidenteLocal === true" v-model="actual.t3OtroIncidenteLocalDetalle" class="form-control mt-2" type="text" placeholder="Especifique..." required></textarea>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-xl-2"></div>

            <div v-if="eventosActualizacion.length > 0" v-html="eventosActualizacion"></div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped>
.table-hover tbody tr:hover {
  background-color: #f9f9f9;
}
</style>

<script>
export default {
  name: "ficha-turno-3-local-2026",
  components: {},
  props: {
    localVotacionId: {
      type: Number,
    },
    procesoElectoralId: {
      type: Number,
    },
    expandirContenido: {
      type: Boolean,
    },
    intervaloAutoGuardado: {
      type: Number,
    },
  },
  data: () => ({
    finalizado: false,
    auth: {
      autorizadoEdicionTurno: null,
      mensajeNoAutorizadoEdicionTurno: null,
      puedeCambiarEstadoFinalizado: null,
      puedeEditarTurno: null,
      puedeVisualizarTurno: null,
      puedeFinalizarTurno: null,
      puedeReanudarTurno: null,
      fechaInicioTurno: null,
      fechaFinTurno: null,
      fechaInicioEdicionTurno: null,
      fechaFinEdicionTurno: null,
    },
    ui: {
      colLeftClass: "col-sm-12 col-md-5",
      colRightClass: "col-sm-12 col-md-7",
      estaGuardando: false,
      estaCargandoDatos: false,
      tieneCargaInicial: false,
    },
    temporizadorGuardado: null,
    eventosActualizacion: [],
    actual: {
      t3LocalCuentaConElectricidad: null,
      t3PresenciaOnpe: null,
      t3PresenciaJne: null,
      t3PresenciaFfaapnp: null,
      t3PresenciaMinisterioPublico: null,
      t3PresenciaDefensoriaDelPueblo: null,
      t3PresenciaOtros: null,
      t3PresenciaOtrosDetalle: null,
      t3HoraCierreLocal: null,
      t3QuedaronPersonasEsperandoSufragar: null,
      t3QuedaronPersonasEsperandoSufragarDetalle: null,
      t3QuedaronPersonasEsperandoSufragarDetalleNo: null,
      t3SePermitioVotarTrasCierre: null,
      t3SePermitioVotarTrasCierreDetalle: null,
      t3SePermitioVotarTrasCierreDetalleNo: null,
      t3ActoIntimidacionOViolencia: null,
      t3ActoIntimidacionOViolenciaDetalle: null,
      t3AccionImpideLaborObservador: null,
      t3AccionImpideLaborObservadorDetalle: null,
      t3ReporteAbandonoMiembroMesaLocal: null,
      t3ReporteAbandonoMiembroMesaLocalDetalle: null,
      t3ReporteAbandonoMiembroMesaLocalNroMesa: null,
      t3AltercadosEntrePersonerosOCiudadanos: null,
      t3AltercadosEntrePersonerosOCiudadanosDetalle: null,
      t3AltercadosOrganizacionesIds: [],
      itemsT3AltercadosEntrePersoneros: [],
      t3OtroIncidenteLocal: null,
      t3OtroIncidenteLocalDetalle: null,
    },
    partidos: [],
    guardado: {
      t3LocalCuentaConElectricidad: null,
      t3PresenciaOnpe: null,
      t3PresenciaJne: null,
      t3PresenciaFfaapnp: null,
      t3PresenciaMinisterioPublico: null,
      t3PresenciaDefensoriaDelPueblo: null,
      t3PresenciaOtros: null,
      t3PresenciaOtrosDetalle: null,
      t3HoraCierreLocal: null,
      t3QuedaronPersonasEsperandoSufragar: null,
      t3QuedaronPersonasEsperandoSufragarDetalle: null,
      t3QuedaronPersonasEsperandoSufragarDetalleNo: null,
      t3SePermitioVotarTrasCierre: null,
      t3SePermitioVotarTrasCierreDetalle: null,
      t3SePermitioVotarTrasCierreDetalleNo: null,
      t3ActoIntimidacionOViolencia: null,
      t3ActoIntimidacionOViolenciaDetalle: null,
      t3AccionImpideLaborObservador: null,
      t3AccionImpideLaborObservadorDetalle: null,
      t3ReporteAbandonoMiembroMesaLocal: null,
      t3ReporteAbandonoMiembroMesaLocalDetalle: null,
      t3ReporteAbandonoMiembroMesaLocalNroMesa: null,
      t3AltercadosEntrePersonerosOCiudadanos: null,
      t3AltercadosEntrePersonerosOCiudadanosDetalle: null,
      t3AltercadosOrganizacionesIds: [],
      itemsT3AltercadosEntrePersoneros: [],
      t3OtroIncidenteLocal: null,
      t3OtroIncidenteLocalDetalle: null,
    },
  }),
  computed: {
    partidosNacionales: function () { return (this.partidos || []).filter(function (p) { return p.regionId == 0; }); },
    partidosRegionales: function () { return (this.partidos || []).filter(function (p) { return p.regionId != 0; }); },
    isDirty: function () {
      return JSON.stringify(this.actual) != JSON.stringify(this.guardado);
    },
    mostrarDetalleFicha: function () {
      if (!this.ui.tieneCargaInicial) return false;
      if (!this.auth.autorizadoEdicionTurno) return false;

      return true;
    },
  },
  methods: {
    inicializarGuardado: function () {
      if (!this.intervaloAutoGuardado || this.intervaloAutoGuardado <= 0) return;
      if (!this.ui.tieneCargaInicial || this.ui.estaCargandoDatos) return;
      if (!this.auth.autorizadoEdicionTurno) return;
      var vm = this;
      clearTimeout(this.temporizadorGuardado);
      this.temporizadorGuardado = setTimeout(function () {
        if (!vm.ui.estaCargandoDatos && !vm.ui.estaGuardando && vm.isDirty) {
          vm.doGuardado(true);
        }
      }, this.intervaloAutoGuardado);
    },
    doCargarFicha: async function () {
      this.ui.estaCargandoDatos = true;
      var model = {
        localVotacionId: this.localVotacionId,
        procesoElectoralId: this.procesoElectoralId,
      };

      await this.$http.post(this.apiRoute("Sheet", "GetFichaTurnoTres"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          var ficha = response.body.data.ficha;

          var tempActual = this.cloneObject(this.actual);
          var tempGuardado = this.cloneObject(this.guardado);

          tempActual.t3LocalCuentaConElectricidad = this.actualizarBaseDiferente("t3LocalCuentaConElectricidad", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaOnpe = this.actualizarBaseDiferente("t3PresenciaOnpe", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaJne = this.actualizarBaseDiferente("t3PresenciaJne", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaFfaapnp = this.actualizarBaseDiferente("t3PresenciaFfaapnp", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaMinisterioPublico = this.actualizarBaseDiferente("t3PresenciaMinisterioPublico", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaDefensoriaDelPueblo = this.actualizarBaseDiferente("t3PresenciaDefensoriaDelPueblo", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaOtros = this.actualizarBaseDiferente("t3PresenciaOtros", tempActual, tempGuardado, ficha);
          tempActual.t3PresenciaOtrosDetalle = this.actualizarBaseDiferente("t3PresenciaOtrosDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3HoraCierreLocal = this.actualizarBaseDiferente("t3HoraCierreLocal", tempActual, tempGuardado, ficha);
          tempActual.t3QuedaronPersonasEsperandoSufragar = this.actualizarBaseDiferente("t3QuedaronPersonasEsperandoSufragar", tempActual, tempGuardado, ficha);
          tempActual.t3QuedaronPersonasEsperandoSufragarDetalle = this.actualizarBaseDiferente("t3QuedaronPersonasEsperandoSufragarDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3QuedaronPersonasEsperandoSufragarDetalleNo = this.actualizarBaseDiferente("t3QuedaronPersonasEsperandoSufragarDetalleNo", tempActual, tempGuardado, ficha);
          tempActual.t3SePermitioVotarTrasCierre = this.actualizarBaseDiferente("t3SePermitioVotarTrasCierre", tempActual, tempGuardado, ficha);
          tempActual.t3SePermitioVotarTrasCierreDetalle = this.actualizarBaseDiferente("t3SePermitioVotarTrasCierreDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3SePermitioVotarTrasCierreDetalleNo = this.actualizarBaseDiferente("t3SePermitioVotarTrasCierreDetalleNo", tempActual, tempGuardado, ficha);
          tempActual.t3ActoIntimidacionOViolencia = this.actualizarBaseDiferente("t3ActoIntimidacionOViolencia", tempActual, tempGuardado, ficha);
          tempActual.t3ActoIntimidacionOViolenciaDetalle = this.actualizarBaseDiferente("t3ActoIntimidacionOViolenciaDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3AccionImpideLaborObservador = this.actualizarBaseDiferente("t3AccionImpideLaborObservador", tempActual, tempGuardado, ficha);
          tempActual.t3AccionImpideLaborObservadorDetalle = this.actualizarBaseDiferente("t3AccionImpideLaborObservadorDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3ReporteAbandonoMiembroMesaLocal = this.actualizarBaseDiferente("t3ReporteAbandonoMiembroMesaLocal", tempActual, tempGuardado, ficha);
          tempActual.t3ReporteAbandonoMiembroMesaLocalDetalle = this.actualizarBaseDiferente("t3ReporteAbandonoMiembroMesaLocalDetalle", tempActual, tempGuardado, ficha);
          tempActual.t3ReporteAbandonoMiembroMesaLocalNroMesa = this.actualizarBaseDiferente("t3ReporteAbandonoMiembroMesaLocalNroMesa", tempActual, tempGuardado, ficha);
          tempActual.t3AltercadosEntrePersonerosOCiudadanos = this.actualizarBaseDiferente("t3AltercadosEntrePersonerosOCiudadanos", tempActual, tempGuardado, ficha);
          tempActual.t3AltercadosEntrePersonerosOCiudadanosDetalle = this.actualizarBaseDiferente("t3AltercadosEntrePersonerosOCiudadanosDetalle", tempActual, tempGuardado, ficha);
          tempActual.itemsT3AltercadosEntrePersoneros = this.actualizarBaseDiferente("itemsT3AltercadosEntrePersoneros", tempActual, tempGuardado, ficha);
          if (!tempActual.itemsT3AltercadosEntrePersoneros || !Array.isArray(tempActual.itemsT3AltercadosEntrePersoneros)) tempActual.itemsT3AltercadosEntrePersoneros = [];
          tempActual.t3OtroIncidenteLocal = this.actualizarBaseDiferente("t3OtroIncidenteLocal", tempActual, tempGuardado, ficha);
          tempActual.t3OtroIncidenteLocalDetalle = this.actualizarBaseDiferente("t3OtroIncidenteLocalDetalle", tempActual, tempGuardado, ficha);

          this.actual = this.cloneObject(tempActual);
          // `guardado` en data() no incluye todas las claves de `actual` (p. ej. t3AltercadosOrganizacionesIds); `ficha` tampoco → alinear con `actual`
          this.guardado = this.cloneObject(this.actual);
          this.auth = response.body.data.auth;
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.tieneCargaInicial = true;
      this.ui.estaCargandoDatos = false;
    },
    actualizarBaseDiferente: function (propiedad, fichaActual, fichaGuardado, fichaActualizada) {
      var valorActual = JSON.stringify(fichaActual[propiedad]);
      var valorGuardado = JSON.stringify(fichaGuardado[propiedad]);
      var valorActualizado = JSON.stringify(fichaActualizada[propiedad]);

      if (valorActual == valorGuardado && valorGuardado != valorActualizado) {
        return fichaActualizada[propiedad];
      } else {
        return fichaActual[propiedad];
      }
    },
    doGuardado: async function (omitirNotificacion) {
      if (this.ui.estaGuardando) return;

      if (!this.isFormValid("frm-turno-3")) {
        if (omitirNotificacion != true) {
          this.$bvToast.toast("Hay campos con valores incorrectos. Revise los datos ingresados.", {
            title: "Turno 3",
            autoHideDelay: 5000,
            variant: "warning",
            appendToast: false,
            solid: true,
          });
        }
        return false;
      }

      var actualClone = this.cloneObject(this.actual);

      var model = this.cloneObject(this.actual);
      model.localVotacionId = this.localVotacionId;
      model.procesoElectoralId = this.procesoElectoralId;
      delete model.t3AltercadosOrganizacionesIds;

      var guardadoExistoso = false;
      this.ui.estaGuardando = true;
      await this.$http.post(this.apiRoute("Sheet", "EditFichaTurnoTres"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.guardado = actualClone;

          if (omitirNotificacion != true) {
            this.$bvToast.toast("Los cambios se han guardado correctamente.", {
              title: "Turno 3",
              autoHideDelay: 5000,
              variant: "success",
              appendToast: false,
              solid: true,
            });
          }
          guardadoExistoso = true;

          this.doCargarFicha();

          this.$notifyHub.notificarCambioFicha(this.procesoElectoralId, this.localVotacionId, 3);
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.ui.estaGuardando = false;
      return guardadoExistoso;
    },
    fetchPartidosPoliticos: function () {
      var self = this;
      this.$http.get(this.apiRoute("Parameter", "ListParametrosPoliticos"), { params: { Id: this.localVotacionId } }).then(function (response) {
        var parameterResponse = response.body && response.body.data ? response.body.data : [];
        self.partidos = parameterResponse;
      });
    },
    addItemPersoneroAltercados: function (arr) {
      if (!arr) return;
      arr.push({ organizacionPoliticaParamId: null, numero: 1 });
    },
    deleteItemPersoneroAltercados: function (arr, item) {
      if (!arr) return;
      var idx = arr.indexOf(item);
      if (idx >= 0) arr.splice(idx, 1);
    },
    getImagenPartidoPolitico: function (partidoPoliticoParamId) {
      var partido = this.partidos.find(function (x) { return x.parametroId == partidoPoliticoParamId; });
      var imagen = partido ? partido.imagen : null;
      if (!imagen) imagen = "app-partidos/_no-image.png";
      return this.apiResource(imagen);
    },
    doToggleFinalizado: async function () {
      if (this.finalizado) {
        if (!(await this.sweetConfirm("¿Desea desbloquear esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      } else {
        if (!(await this.sweetConfirm("¿Desea finalizar esta sección?"))) {
          return;
        }
        this.finalizado = !this.finalizado;
      }
    },
  },
  watch: {
    isDirty: function (newValue) {
      if (newValue && this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0) {
        this.inicializarGuardado();
      } else {
        clearTimeout(this.temporizadorGuardado);
      }
    },
    actual: {
      deep: true,
      handler() {
        if (this.intervaloAutoGuardado && this.intervaloAutoGuardado > 0 && this.ui.tieneCargaInicial && !this.ui.estaCargandoDatos && this.auth.autorizadoEdicionTurno) {
          this.inicializarGuardado();
        }
      },
    },
  },
  mounted: function () {
    this.initParsley();
    this.fetchPartidosPoliticos();
    this.doCargarFicha();
  },
  beforeDestroy: function () {
    clearTimeout(this.temporizadorGuardado);
  },
};
</script>
